module.exports = false;


//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/core-js/modules/_library.js
// module id = 75
// module chunks = 48 49 50 51